// extracted by mini-css-extract-plugin
export default {"red":"DeleteUserForm-module__red___Gjapf","textBlock":"DeleteUserForm-module__textBlock___mHl0w"};